mutation AddEditableGroupValues($values: [String]!, $editableGroupName: ID!, $campaignId: ID!) {
    addEditableGroupValues(editableGroupName: $editableGroupName, values: $values, campaignId: $campaignId) {
        _id
        editableGroupName
        value
    }
}
